import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { menuItems } from "../consts";
import { ChevronDown, ChevronUp, PhoneCall, X } from "lucide-react";
import { cn } from "@/lib/utils";

const MobileMenu = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  return (
    <div
      className={`fixed top-0 left-0 w-full h-full bg-white shadow-lg transform transition-transform duration-300 z-50 ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* Header with Logo & Close */}
      <div className="flex justify-between items-center px-6 py-4 border-b">
        <img src="/img/logo.png" alt="Logo" className="h-8" />
        <button onClick={onClose} className="text-2xl">
          <X />
        </button>
      </div>

      {/* Menu List */}
      <div className="flex flex-col divide-y">
        {menuItems.map((item, index) => {
  // Check if the main item or any of its children match current location
  const isActive =
    location.pathname === item.to ||
    (item.children?.some(
      (child) =>
        location.pathname === child.to ||
        location.pathname.startsWith(`${child.to}/`)
    ) ?? false);

  // For submenu items: check if this child is active
  const isChildActive = (to: string) =>
    location.pathname === to || location.pathname.startsWith(`${to}/`);

  return (
    <div key={index}>
      <div
        className={cn(
          "flex justify-between items-center px-6 py-4 cursor-pointer transition-all",
          isActive ? "text-primary font-bold" : ""
        )}
        onClick={() =>
          item.children
            ? setOpenMenu(openMenu === item.title ? null : item.title)
            : onClose()
        }
      >
        {/* If no children, make whole title clickable */}
        {!item.children ? (
          <Link to={item.to || "#"}>{item.title}</Link>
        ) : (
          <span>{item.title}</span> // For parent with children, no link on main title
        )}

        {item.children &&
          (openMenu === item.title ? (
            <ChevronUp size={20} />
          ) : (
            <ChevronDown size={20} />
          ))}
      </div>

      {/* Submenu */}
      {item.children && openMenu === item.title && (
        <div
          className={cn(
            "bg-g-60 overflow-hidden transition-all duration-300 ease-in-out",
            openMenu === item.title
              ? "max-h-60 opacity-100"
              : "max-h-0 opacity-0"
          )}
        >
          {item.children.map((sub, i) => (
            <Link
              key={i}
              to={sub.to}
              onClick={onClose}
              className={cn(
                "block px-10 py-3 border-b border-g-600 hover:text-primary",
                isChildActive(sub.to) ? "text-primary font-bold" : ""
              )}
            >
              {sub.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
})}

        <div className="flex items-center mx-4 my-3">
          <div className="h-7 w-7 rounded-full bg-primary mt-[-20px] flex items-center justify-center">
            <PhoneCall className="h-4 w-4 stroke-white" />
          </div>
          <a
            href="tel:+918801230123"
            className="ml-2 font-[700]"
          >
            +91 8801230123
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
